<template>
    <div class="offboarding-fusebox-info">
        <svg-vue class="logo" icon="horizontal" />
        <p class="features-title">
            Fusebox Free includes:
        </p>
        <div v-if="products" class="fusebox-products">
            <template v-for="( product, index ) in products">
                <p
                    :key="product.name"
                    class="product-title"
                >
                    <template v-if="index === 0">
                        <img src="/images/player_logo.svg" alt="Fusebox">
                    </template>
                    <template v-else>
                        <img src="/images/transcript_logo.svg" alt="Fusebox">
                    </template>
                    {{ product.name }}
                </p>
                <div
                    :key="product.id"
                    class="product-list flex"
                >
                    <ul>
                        <template v-for="feature in product.feature_list">
                            <li
                                v-if="!feature.pro"
                                :key="feature.name"
                            >
                                {{ feature.name }}
                            </li>
                        </template>
                    </ul>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: mapState(['products']),
};
</script>
